<template>

    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-street-view" aria-hidden="true"></i> {{title}}</div>
        <div class="panel-body">
            <form class="form-horizontal" >

                <div class="form-group">

                    <div class="col-sm-9">
                        <label class="control-label">ENDEREÇO</label>
                        <input :disabled="disabled" type="text" v-model="street.endereco" class="form-control" >
                    </div>

                    <div class="col-sm-3">
                        <label class="control-label">NÚMERO</label>
                        <input :disabled="disabled" type="text" v-model="street.numero" class="form-control" >
                    </div>

                    <div class="col-sm-9">
                        <label class="control-label">CIDADE</label>
                        <input :disabled="disabled" type="text" v-model="street.cidade" class="form-control" >
                    </div>

                    <div class="col-sm-3">
                        <label class="control-label">ESTADO</label>
                        <input :disabled="disabled" type="text" v-model="street.estado" class="form-control" >
                    </div>

                    <div class="col-sm-6">
                        <label class="control-label">BAIRRO</label>
                        <input :disabled="disabled" type="text" v-model="street.bairro" class="form-control" >
                    </div>

                    <div class="col-sm-6">
                        <label class="control-label">COMPLEMENTO</label>
                        <input :disabled="disabled" type="text" v-model="street.complemento" class="form-control" >
                    </div>

                </div>
            </form>
        </div>
    </div>

</template>
<script>
import { Street } from "../class/street";
export default {
    props: {
        street: {
            type: Object,
            default: () => Street.create()
        },
        disabled: {
            default: true
        },
        title: {
            default: "ENDEREÇO"
        }
    }
};
</script>
